<template>
  <div>

   <label class="col-form-label font-weight-bold"> {{text}} </label>
   <input v-model="newvalor"  :type="tipo" class="form-control p-3" :placeholder="placeholder" :disabled="disabled" :readonly="readonly">
  
  </div>
</template>

<script>
export default {

  data(){
    return{
      valor : '',
      newvalor : '',
    }
  },

props: {
  text : String,
  tipo : String,
  placeholder : '',
  readonly : String,
  disabled : String,
  valor : String
},

watch : {
  
 newvalor(val){       
  
   this.$emit('eventInput', val)

   }
}

}
</script>

<style >
.flex{
 
 flex-direction: column;
   
}

.col-form-label {
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
}
.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--inputColor);
    background-color: var(--white);
    background-clip: padding-box;
    border: 1px solid var(--greyBtn);
    border-radius: 0.35rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}



.form-control:focus {
    color: var(--inputColor);
    background-color: var(--white);
    border-color: #baf3cd;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
    animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}



</style>
